import { Component } from '@angular/core';

@Component({
  selector: 'app-file-shower',
  templateUrl: './file-shower.component.html',
  styleUrl: './file-shower.component.scss'
})
export class FileShowerComponent {

}
